import * as React from 'react';

import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {OptOutModalGraphic} from './assets';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function MessageOptOutModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<OptOutModalGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>Opt-out</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            People can opt out of receiving more messages when texting an opt-out
                            keyword.
                        </ModalBody>
                    </SpacerGroup>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            Nutshell keeps track of all opted-out people for you, so you never have
                            to worry about sending text messages to those folks again.
                        </ModalBody>
                    </SpacerGroup>
                </div>
            }
        />
    );
}
